import React from 'react';
import CogitoLogo from '../../../components/ui/CogitoLogo';

const LoginHeader = ({ className = '' }) => {
  return (
    <div className={`text-center space-y-4 ${className}`}>
      {/* Logo */}
      <div className="flex items-center justify-center">
        <CogitoLogo size="md" showWordmark={false} interactive={false} className="pointer-events-none" />
      </div>

      {/* Welcome Text */}
      <div className="space-y-2">
        <h1 className="text-2xl font-semibold text-foreground">Welcome back to Cogito</h1>
        <p className="text-muted-foreground max-w-md mx-auto leading-relaxed">
          Sign in to continue your learning journey and access your personalized AI-powered learning coach.
        </p>
      </div>

      {/* Current Status Indicator */}
      <div className="inline-flex items-center space-x-2 px-3 py-1 bg-accent/10 rounded-full">
        <div className="w-2 h-2 bg-accent rounded-full animate-pulse"></div>
        <span className="text-xs font-medium text-accent">Learning Platform Active</span>
      </div>
    </div>
  );
};

export default LoginHeader;